import React, { useState, useEffect, useCallback } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { Row, Col, Button, Collapse } from "reactstrap";
import CurrencyFormat from "react-currency-format";
import _ from "lodash";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from "react-share"

// IMPORT COMPONENT
import { ProtectedButton } from "../../../../Forms";
import SizeChart from "./Sizes/SizeChart";
import Sizes from "./Sizes";
import {
  HowDoesOfferWorks
} from "../../../../Modals/StaticInfoModal/ModalStaticInfo"

// IMPORT HERLPERS
import { convertToRupiah } from "../../../../../utils";
import {
  dustBag,
  boxHandbag,
  boxCondition,
  detailCondition,
  defectCondition,
  handbagCondition as handbagConditionFn,
  sneakersCondition,
  accessoriesCondition,
  detailHandbagCondition,
  formatCurrency,
  estimatedTimeArrivals as estimatedTimeArrivalsHelper
} from "../../../../../utils/Helpers";
import Analytics from "../../../../../services/Analytics";
import { OFFER_DEPOSIT, OFFER_GAP } from '../../../../../config';

// IMPORT ACTION
import { postShoppingCartProduct } from "../../../../../actions/shoppingCartAction";
import {
  doValidateOffer,
  doPostUserOffer,
  doBidValidation,
  doFetchOfferPending
} from "../../../../../actions/offerAction";

import {
  getTicketListSetting
} from "../../../../../actions/productAction";

// IMPORT ASSETS
import BackButton from "../../../../../images/shopping-cart-back.png";
import InstagramIcon from "../../../../../images/shareSosmed30/instagram30.png";
import FacebookIcon from "../../../../../images/shareSosmed30/facebook30.png";
import WhatsappIcon from "../../../../../images/shareSosmed30/whatsapp30.png";
import TwitterIcon from "../../../../../images/shareSosmed30/twitter30.png";
import EmailIcon from "../../../../../images/shareSosmed30/mail30.png";
import CopyIcon from "../../../../../images/shareSosmed30/copy30.png";
import PlusIcon from "../../../../../images/plus30.png";
import MinusIcon from "../../../../../images/minus-black.png";
import PreVerifiedIcon from "../../../../../images/pre-verified30.png";
import HotProductIcon from "../../../../../images/hot_product30.png";
import AddToBag from "../../../../../images/addtobag30.png";
import Continue from "../../../../../images/continue.png";
import HotProductIconWhite from "../../../../../images/hot-product-white.png";
import KaFair from "../../../../../images/ka_fair.png";
import PreVerifiedUnderRetail from "../../../../../images/preverified_disc.png";
import { ModalAlert } from "../../../../Modals";

//IMPORT HOOKS
import { useEtaText } from "../../../../../helpers/dom"

// import { ModalAlert } from "../../../../../Modals";
// import { stat } from "fs";

const RenderCategoryInformation = ({
  classnames,
  imgUlr,
  text
}) => {
  return (
    <div className={`element-icon ${classnames}`}>
      {imgUlr && <KickImage src={imgUlr} alt="..." />}
      <p>{text}</p>
    </div>
  )
}

function LeftContent({
  propsForLeftContent,
  isKickFairActive,
  doBidValidation,
  doPostUserOffer,
  doFetchOfferPending,
  offerPending,
  getTicketListSetting,
  ...props
}) {
  /* PROPS DECONSTRUCT */
  const {
    product: variant = {},
    history,
    dataAuth,
    selectedSize,
    usedSizes = [],
    productDetail,
    isVintage,
    installments,
    onSizeChanged,
    onSizeCollapseChanged,
    availableSizes,
    preOrderSizes,
    vintageList,
    sizeCollapse,
    onBuy,
    onOfferClick,
    handbagCondition,
    dataValidations,
    currentURL,
    handleDataInProcess,
    start_from_price,
    product: _product,
    setHideAllDetails,
    setIsHideTumbnail
  } = propsForLeftContent;

  const [state, setState] = useState({
    currentPage: "1",
    productCondition: "",
    dataForAddToBacSection: {},
  });

  // DEFINING VARIABEL
  const {
    id = "",
    display_name = "",
    SKU = "",
    colour = "",
    type = "",
    dimensions = "",
    release_date = "",
    retail_price = "",
    currency = "",
    hide_box_info = "",
    product = {},
    biddable
  } = variant;

  const { isLogged, userdata = {}, userCurrency: newUserCurrency = {} } = dataAuth;
  const isIndonesian = isLogged && userdata && userdata.country_code === 'IDN'
  const { asking_price = "" } = usedSizes[0] || {};
  let userCurrency = newUserCurrency;

  const { bid: { isFetch } = {} } = dataValidations || {};

  const {
    subsidy_price,
    asking_price: selectedAskingPrice,
    highest_bid: selectedHighestBid,
    product_variant: {
      editors_choice,
      id: _product_variant_id
    } = {}
  } = selectedSize || {};

  const brands = product.brand_id ? product.brand.flat : [];
  const category = product.category ? product.category.name : "";
  const roleNotAlloweds = ["unverified_user"];
  const userRole = userdata.roles || [];

  const selected = selectedSize;
  const [isOpenTopNote, setIsOpenTopNote] = useState(false);
  const [isOpenBottomNote, setIsOpenBottomNote] = useState(true);
  const [switchStatus, setSwitchStatus] = useState("standard")
  const [inputOffer, setInputOffer] = useState(0)
  const [continueToMakeOfferAvailable, setContinueToMakeOfferAvailable] = useState(false)
  const [bidRules, setBidRules] = useState("")
  const [productConditionsString, setProductConditionsString] = useState("")
  const [isToggleAvailable, setIsToggleAvailable] = useState(false)
  const [otherProduct, setOtherProduct] = useState({})
  const [selectedProduct, setSelectedProduct] = useState({})
  const [changeDataFlagging, setChangeDataFlagging] = useState(false)
  const [estimatedTimeArrivals, setEstimatedTimeArrivals] = useState("")
  const [openOfferInfo, setOpenOfferInfo] = useState(false)
  const [modalAlertOpen, setModalAlertOpen] = useState(false)
  const [openModalSizeChart, setOpenSizeChart] = useState(false)

  const [isShowPreferiviedInfo, setIsShowPreferiviedInfo] = useState(false)
  const [isShowHotProductInfo, setIsShowHotProductInfo] = useState(false)
  const [ticketList, setTicketList] = useState('');

  const shareUrl = window.location.href

  const [etaTextObject] = useEtaText()

  /* CALLBACK FUNC */
  const roundedInput = useCallback(_.debounce((input) => {
    if (input < 50000) {
      setInputOffer(50000)
    } else {
      setInputOffer(fixingAmount(input || 0))
    }
  }, 1500), [])


  /* RENDER COMPONENT BY FUNCTION*/
  const renderSellButton = () => {
    const isTicket =  ticketList.includes(variant?.SKU);
    const isSeller = isRender.sellButton && variant.receive_sell;
    const sellButton = isTicket ? (isSeller && userRole.includes('seller_ticket')) : isSeller;
    
    return sellButton ? (
      <ProtectedButton
        isLogged={isLogged}
        userData={userdata}
        countryCodeAllowed={[null, "IDN"]}
        className="btn-white flat"
        roleNotAlloweds={roleNotAlloweds}
        buttonText="SELL"
        category={category}
      >
        <Link
          to={{
            pathname: `/sell-request?category=${category}&productId=${id}`,
            id: id,
            state: display_name,
            selected: selected,
            category: category,
            hide_box_info: hide_box_info,
          }}
          target={"_blank"}
          className="btn btn-secondary btn-white flat"
          style={{
            marginTop: 0
          }}
        >
          Sell
        </Link>
      </ProtectedButton>
    ) : null;
  };

  /* DEFINE LOCAL METHOD / FUNCTION */
  const _isVilla = () => {
    const DETERMINED_KEYWORD = "FILA";

    if (!display_name) return;

    return display_name
      .toLowerCase()
      .includes(DETERMINED_KEYWORD.toLowerCase());
  };

  const _validButtonBuy = () => {
    if (selectedSize) {
      const A = selectedSize.hasOwnProperty("id");
      if (A === true) {
        return false;
      } else {
        return true;
      }
    }
  };

  const renderButtonBuyOffer = () => {
    if (!selectedSize) return null;

    return (
      <div>
        <Row>
          <Col>
            <ProtectedButton
              isLogged={isLogged}
              userData={userdata}
              roleNotAlloweds={["unverified_user"]}
              className={classnames(
                { disabled: selectedSize === null, "d-none": id === undefined },
                "btn-green bold"
              )}
              disabled={_validButtonBuy()}
              color="success"
              block
              size="lg"
              buttonText="BUY NOW"
              onClick={onBuy}
              loadingText="BUY NOW"
            />
          </Col>
          <Col>
            <ProtectedButton
              isLogged={isLogged}
              userData={userdata}
              roleNotAlloweds={["unverified_user"]}
              countryCodeAllowed={[null, "IDN"]}
              className={classnames(
                { "": selectedSize === null, "d-none": id === undefined },
                parseInt(selectedSize.subsidy_price) === 0 ||
                  !selectedSize.subsidy_price
                  ? "btn-red  bold flat spacer"
                  : "btn-white  bold flat spacer subsidy"
              )}
              style={{ margin: "0", width: "100%" }}
              color="success"
              size="lg"
              disabled={isFetch}
              loadingText="LOADING..."
              buttonText="MAKE OFFER"
              onClick={onOfferClick}
            />
          </Col>
        </Row>
      </div>
    );
  };

  const handleCurrentPage = (nextPage, productCondition, data) => {
    if(!isLogged){
      history.push({
        pathname: '/login',
        state: { 
          isFromProductDetail: true,
          redirectPath: history.location.pathname,
          redirectSearch: history.location.search 
        }
      });
      return;
    }
    onSizeCollapseChanged(productCondition || state.productCondition);
    setState({
      ...state,
      productCondition,
      currentPage: nextPage,
      dataForAddToBacSection: data,
    });
  };

  const goToAddToBagSection = async (page, data) => {
    const { isCollapse } = data;
    await handleCurrentPage(page, isCollapse, data);
  };

  const _goToInputOffer = (selectedSize, slug, productId, dataAuth, bid, _bidAmount) => {
    if (selectedSize) {
      const {
        box_condition,
        id,
        size_id,
        size,
        missing_accessories,
        sneakers_defect,
        yellowing,
        sneakers_condition,
        display_item,
        defects
      } = selectedSize;

      Analytics.recordInitiateOffer(
        display_name,
        category,
        SKU,
        "product",
        _bidAmount,
        "IDR"
      );
    }
  }

  const changePageHandler = () => {
    const { status } = state.dataForAddToBacSection || {}
    const page = status === "offer-now" ? "offer" : "checkout"
    const url = currentURL.url;

    if (status === "offer-now") {
      const slug = currentURL.params.slug
      _goToInputOffer(selectedProduct, slug, _product.id, dataAuth, dataValidations.bid, inputOffer)
    }

    handleDataInProcess({ ...state.dataForAddToBacSection, sell: selectedProduct, etaText: estimatedTimeArrivals, inputOffer, productCondition: productConditionsString }, propsForLeftContent, status);
  };

  const handleProductToShoppingCart = () => {
    const {
      productCondition,
      isCollapse,
      etaText,
      sizeForDesc,
      pre_verified,
      buyNowPrice,
      highestOffer,
      pre_order,
      category,
      item,
      sell,
      size,
    } = state.dataForAddToBacSection;

    const payload = {
      type: "product",
      category,
      SKU: item.product_variant.SKU,
      product_variant_id: item.product_variant.id,
      user_sell_id: sell.id,
      size_id: size.id,
      sneakers_condition: item.sneakers_condition,
      box_condition: item.box_condition,
      price: buyNowPrice ? Number(buyNowPrice) : 0, //must be in numeric yaa
      pre_orders: pre_order,
    };

    postShoppingCartProduct(payload);
  };

  const handleBidAmountRules = (bidAmount) => {
    const { amount = 0 } = selectedHighestBid || {}

    if (bidAmount / userCurrency.ratio == (parseFloat(selectedAskingPrice) - parseInt(subsidy_price || 0))) {
      const price = convertToRupiah(parseFloat((selectedAskingPrice * userCurrency.ratio) - parseInt(subsidy_price || 0)))
      // setBidRules(`Cannot make an offer with the same price ${currency} ${price}`)
      setBidRules(`Cannot make an offer with the same price ${userCurrency.currency} ${price}`)
      setContinueToMakeOfferAvailable(false);
    } else if (bidAmount / userCurrency.ratio > (parseFloat(selectedAskingPrice) - parseInt(subsidy_price || 0))) {
      const price = convertToRupiah(((selectedAskingPrice - parseInt(subsidy_price || 0)) * userCurrency.ratio))
      // setBidRules(`Cannot make an offer greater than ${currency} ${price} `);
      setBidRules(`You cannot put higher offer than the buy now price ${price}`);
      // setBidRules(`You cannot put higher offer than the buy now price`);
      setContinueToMakeOfferAvailable(false);
    } else {
      if (bidAmount / userCurrency.ratio > parseFloat(amount)) {
        if ((bidAmount || 0) < 50000) {
          setBidRules(`Minimum offer is IDR 50.000`)
        } else {
          setBidRules(`You have the highest offer.`)
        }
      }
      setContinueToMakeOfferAvailable(((bidAmount || 0) < 50000) ? false : true);
    }
  }

  const onChangeOfferPrice = (e) => {
    handleBidAmountRules(e.floatValue)
    setInputOffer(e.floatValue || 0)
    roundedInput(e.floatValue || 0)
  }

  const onBlur = () => setInputOffer(fixingAmount(inputOffer))

  const handleProductConditions = () => {
    const {
      missing_accessories,
      sneakers_defect,
      sneakers_condition,
      yellowing,
      display_item,
      defects,
      box_condition,
      hide_box_info
    } = selectedProduct || {}

    const uniqueDefects = _.uniqBy(defects, "name");
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find(a => a.name === "DUST_BAG")
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find(a => a.name === "BOX")
      : {};
    const boxConditionNew = hide_box_info
      ? null
      : boxCondition(box_condition);
    const productDefects = uniqueDefects.length > 0 ? uniqueDefects.filter(item => item.value).map(item => item.display_name) : [];

    const generalConditions = [
      sneakersCondition(sneakers_condition),
      boxConditionNew,
      accessoriesCondition(missing_accessories),
      yellowing ? "Yellowing" : null,
      sneakers_defect ? "Defect" : null,
      display_item ? "Display Item" : null
    ];
    const ProductConditions = [...generalConditions, ...productDefects];
    const productConditionDetail = ProductConditions
      .filter(item => item !== null)
      .map(item => item)
      .join(", ");

    const _handbagCond = sneakers_defect ? handbagConditionFn(uniqueDefects) : ""
    const luxuryDetailArr = [
      sneakersCondition(sneakers_condition),
      accessoriesCondition(missing_accessories),
      dustBag(dustBagCondition && dustBagCondition.value),
      boxHandbag(boxConditions),
      _handbagCond
    ];
    const luxuryDetail = luxuryDetailArr
      .filter(item => item !== "" && item !== "Missing Box")
      .map(item => item)
      .join(", ");

    setProductConditionsString(category === "handbags" ? luxuryDetail : productConditionDetail)
  };

  const handleTogglePreverified = (products) => {
    setOtherProduct(selectedSize)
    if (products.length <= 1) {
      setIsToggleAvailable(false)
      return
    }

    const productsFiltered = products.filter(item => item.id !== selectedSize.id && item.size_id === selectedSize.size_id && item.pre_verified !== selectedSize.pre_verified)

    if (!productsFiltered || productsFiltered.length === 0) {
      setIsToggleAvailable(false)
      return
    }

    setIsToggleAvailable(true)
    setOtherProduct(productsFiltered[0])
  }

  const handleSwitchStatus = (status) => {
    if (switchStatus === status) return
    setChangeDataFlagging(!changeDataFlagging)
    setSwitchStatus(status)
  }

  const fixingAmount = value => {

    let parsed = parseFloat(value);
    parsed -= (value % OFFER_GAP)
    let summary = parsed + OFFER_GAP
    let multipleGAP = value % OFFER_GAP;

    return parsed < OFFER_GAP ? OFFER_GAP : (multipleGAP === 0 ? parsed : summary);
  }

  const showPreverifiedInfoHandler = (isPrever) => {
    isPrever && setIsShowPreferiviedInfo(isPrever)
  }

  const showHotProductInfoHandler = (isHotProduct) => {
    isHotProduct && setIsShowHotProductInfo(isHotProduct)
  }

  const isOnlyKickPoint = _product?.variant_payment_methods?.length === 1 && !!_product?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point");
  userCurrency = isOnlyKickPoint ? {
    currency: "KP",
    ratio: 1
  } : userCurrency

  /* DEFINE FLAGGING CONDITION TO RENDER COMPONENT */
  const isRender = {
    sellButton:
      (() =>
        !isVintage &&
        ((category === "apparels" && userRole.includes("seller_apparel")) ||
          (category === "sneakers" && userRole.includes("seller")) ||
          (category === "handbags" && userRole.includes("seller_handbag")) ||
          (category === "lifestyles" &&
            userRole.includes("seller_lifestyle"))))() || false,
  };

  const is = {
    SizeData: availableSizes.length > 0,
    disableBrandNew: availableSizes.length > 0 ? false : true,
    disablePreOwned: usedSizes.length > 0 ? false : true,
    disablePreOrder: preOrderSizes.length > 0 ? false : true,
    disableVintage: vintageList.length > 0 ? false : true,
  };

  useEffect(() => {
    getTicketListSetting()
      .then(async (res) => {
        setTicketList(
          await res?.value?.data?.data[0]?.value.split(",") ?? '',
        )
      })
  }, [])

  useEffect(() => {
    if (history && history.location && history.location.state && history.location.state.selectedCondition) {
      setTimeout(() => {
        onSizeCollapseChanged(history.location.state.selectedCondition);
        setState({
          ...state,
          currentPage: '2',
        });
      }, 2000);
    }
  }, [])

  useEffect(() => {
    const {
      status = "",
      sell = {}
    } = state.dataForAddToBacSection || {}

    status === "buy-now" ? setContinueToMakeOfferAvailable(true) : setContinueToMakeOfferAvailable(false)

  }, [state.dataForAddToBacSection, state.currentPage])

  useEffect(() => {
    if (state.currentPage === "3") {
      // STEP 1
      setSelectedProduct(selectedSize)

      // STEP 2
      handleProductConditions()

      // STEP 3
      selectedSize && selectedSize.pre_verified ? setSwitchStatus("pre-verified") : setSwitchStatus("standard")

      switch (sizeCollapse) {
        case "NEW":
          handleTogglePreverified(availableSizes)
          break
        case "USED":
          handleTogglePreverified(usedSizes)
          break
        default:
          handleTogglePreverified(preOrderSizes)
          break
      }
    } else {
      setHideAllDetails(false)
      setOtherProduct(null)
      setChangeDataFlagging(false)
      setState({
        ...state,
        dataForAddToBacSection: {}
      })
    }

    if (state.currentPage === "2") {
      setHideAllDetails(true)
    } else if (state.currentPage === "1") {
      setOpenSizeChart(false)
    }

    if (state.currentPage === "2") {
      setIsHideTumbnail(true)
      setIsShowPreferiviedInfo(false)
    } else {
      setIsShowPreferiviedInfo(false)
      setIsHideTumbnail(false)
    }
  }, [state.currentPage, selectedSize])

  useEffect(() => {
    if (state.currentPage === "3") {
      !changeDataFlagging ? setSelectedProduct(selectedSize) : setSelectedProduct(otherProduct)
    }
  }, [changeDataFlagging])

  useEffect(() => {
    if (state.currentPage === "3") {
      const {
        pre_verified
      } = selectedProduct || {}

      const {
        isCollapse
      } = state.dataForAddToBacSection || {};

      const etaText = estimatedTimeArrivalsHelper(pre_verified, isKickFairActive, isCollapse, etaTextObject)
      setEstimatedTimeArrivals(etaText)
      handleProductConditions()

      if (status !== "buy-now") {
        if (userdata.id) doBidValidation();
        doFetchOfferPending({ user_sell_id: selectedProduct?.id }, "pending")
      }
    }
  }, [selectedProduct])

  useEffect(() => {
    const { dataOfferPending } = offerPending || {}
    if (dataOfferPending.length > 0) {
      const userBid = dataOfferPending.find(bid => {
        return bid.size_id === selectedProduct.size_id && bid.product_variant_id === selectedProduct.product_variant_id
      })
      setInputOffer(userBid?.amount)
      setContinueToMakeOfferAvailable(true)
    } else {
      setInputOffer(0)
    }
  }, [offerPending])

  function _renderModalSizeChart() {
    if (category !== "lifestyle" && category !== "lifestyles" && category !== "toys" && category !== "electronics-collectibles" && category !== "handbags" && category !== "luxury") {
      return (
        <div className="size-chart">
          <SizeChart flaggingIsOpenSizeChart={setOpenSizeChart} category={category} />
        </div>
      )
    }
  }

  /* RENDER CONTENT */
  if (state.currentPage === "3") {
    const {
      etaText,
      isCollapse,
      sizeForDesc,
      pre_verified,
      status,
      // buyNowPrice
    } = state.dataForAddToBacSection;

    const {
      asking_price,
      highest_bid = {},
      total_subsidy
    } = selectedProduct || {}

    const { amount: highestOffer = 0 } = highest_bid || {}

    const buyNowPrice = (() => {
      return total_subsidy && parseInt(total_subsidy) > 0 ? total_subsidy : asking_price;
    })();

    return (
      <>
        <div className="left-content-3">
          {status === "buy-now" ?
            (
              <div className="switch-btn-wrapper">
                <div className={`switch-btn-container ${!isToggleAvailable ? "disabled" : ''}`}>
                  <div
                    onClick={() => isToggleAvailable && handleSwitchStatus("standard")}
                    className={`standard-wrapper ${switchStatus === "standard" ? "active" : ""} `}>
                    <p>Standard</p>
                  </div>
                  <div
                    onClick={() => isToggleAvailable && handleSwitchStatus("pre-verified")}
                    className={`pre-verified-wrapper ${switchStatus === "pre-verified" ? "active" : ""} `}>
                    <p>Express Shipping</p>
                  </div>
                  <div className={`animation-switch-wrapper ${switchStatus === "standard" ? "standard" : "pre-verified"} `}></div>
                </div>
              </div>
            )
            :
            (
              <div className="how-does-offer-work-wrapper">
                <p>How does offer work?</p>
                <p onClick={() => setOpenOfferInfo(!openOfferInfo)}><u>See our offer terms and conditions</u></p>
              </div>
            )
          }
          {
            biddable ?
              <div className="buy-offer-btn-container">
                <div className="outer-container-buy-offer">
                  <div className="buy-now-make-offer-wrapper">
                    <div
                      className={`buy-now-btn-wrapper ${!isIndonesian ? "no-make-offer" : ""} ${status === "buy-now" ? "active" : ""} `}
                      onClick={() =>
                        setState({
                          ...state,
                          dataForAddToBacSection: {
                            ...state.dataForAddToBacSection,
                            status: "buy-now",
                          },
                        })
                      }
                    >
                      <p>Buy Now</p>
                      {
                        window.innerWidth >= 769 ?
                          <p>Lowest Ask {formatCurrency(parseInt(buyNowPrice), userCurrency.ratio, userCurrency.currency)}</p>
                          :
                          <>
                            <p>Lowest Ask</p>
                            <p>{formatCurrency(parseInt(buyNowPrice), userCurrency.ratio, userCurrency.currency)}</p>
                          </>
                      }
                    </div>
                    {isIndonesian &&
                      <div
                        className={`make-offer-btn-wrapper ${status === "offer-now" ? "active" : ""} `}
                        onClick={() => {
                          if (isLogged && userdata && userdata.country_code) {
                            if (userdata.country_code !== 'IDN') {
                              setModalAlertOpen(!modalAlertOpen)
                            } else {
                              setState({
                                ...state,
                                dataForAddToBacSection: {
                                  ...state.dataForAddToBacSection,
                                  status: "offer-now",
                                },
                              })
                            }
                          }
                        }}
                      >
                        <p>Make Offer</p>
                        {
                          window.innerWidth >= 769 ?
                            <p>
                              Highest Offer {highestOffer ? `${formatCurrency(parseInt(highestOffer), userCurrency.ratio, userCurrency.currency)}` : "-"}
                            </p>
                            :
                            <>
                              <p>Highest Offer</p>
                              <p>{highestOffer ? `IDR ${convertToRupiah(parseInt(highestOffer))}` : "-"}</p>
                            </>
                        }
                      </div>
                    }
                  </div>
                  <div className="buy-offer-price-wrapper">
                    {status === "buy-now" ?
                      <p>
                        {formatCurrency(parseInt(buyNowPrice), userCurrency.ratio, userCurrency.currency)}
                      </p>
                      :
                      <div className="input-offer-price">
                        <p>{userCurrency?.currency ?? "IDR"}</p>
                        <CurrencyFormat
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          value={inputOffer === 0 ? "" : inputOffer}
                          placeholder="Enter Your Offer"
                          autocomplete="off"
                          onValueChange={onChangeOfferPrice}
                          name="offerAmount"
                          onBlur={onBlur}
                        />
                      </div>
                    }
                  </div>
                </div>
                {status !== "buy-now" && inputOffer > 0 && <div className="error-messages">
                  <p className={`${bidRules === "You have the highest offer." ? "text-green" : ""}`}>{bidRules}</p>
                </div>}
              </div>
              :
              <div className="buy-now-only-container">
                <div className="buy-now-only-wrapper">
                  <div className="title">
                    <p>Buy Now</p>
                  </div>
                  <div className="price">
                    <p>
                      {formatCurrency(parseInt(buyNowPrice), userCurrency.ratio, userCurrency.currency)}
                    </p>
                  </div>
                </div>
              </div>
          }
          <div className="buyoffer-description-container">
            <div className="decs-per-div-wrapper">
              <div>
                <p>Size</p>
                <p>{sizeForDesc}</p>
              </div>
              <div>
                <p>Condition</p>
                <p>{productConditionsString}</p>
              </div>
              <div>
                <p>Estimated Time of Arrival</p>
                <p>{estimatedTimeArrivals} {`${switchStatus === "standard" ? "" : ""}`}</p>
              </div>
            </div>
          </div>
          {window.innerWidth <= 769 ? !openOfferInfo && <div className="add-to-bag-container">
            <div className="add-to-bag-wrapper">
              <div onClick={() => {
                handleCurrentPage("2", isCollapse)
                setInputOffer(0)
              }}>
                <KickImage src={BackButton} alt="..." />
                <p>Back</p>
              </div>
              {/* UNCOMING FEATURE: ADD TO BAG */}

              {/* <div onClick={() => handleProductToShoppingCart()}>
              <KickImage src={AddToBag} alt="..." />
              <p>Add to Bag</p>
            </div> */}

              <div onClick={() => {
                if (status === "buy-now") {
                  changePageHandler()
                } else {
                  continueToMakeOfferAvailable && inputOffer && changePageHandler()
                }
              }} className={`${status !== "buy-now" && !continueToMakeOfferAvailable ? "disabled" : ""} `}>
                <p>Continue</p>
                <KickImage src={Continue} alt="..." />
              </div>
            </div>
          </div>
            :
            <div className="add-to-bag-container">
              <div className="add-to-bag-wrapper">
                <div onClick={() => {
                  handleCurrentPage("2", isCollapse)
                  setInputOffer(0)
                }}>
                  <KickImage src={BackButton} alt="..." />
                  <p>Back</p>
                </div>
                {/* UNCOMING FEATURE: ADD TO BAG */}

                {/* <div onClick={() => handleProductToShoppingCart()}>
              <KickImage src={AddToBag} alt="..." />
              <p>Add to Bag</p>
            </div> */}

                <div onClick={() => {
                  if (status === "buy-now") {
                    changePageHandler()
                  } else {
                    continueToMakeOfferAvailable && inputOffer && changePageHandler()
                  }
                }} className={`${status !== "buy-now" && !continueToMakeOfferAvailable ? "disabled" : ""} `}>
                  <p>Continue</p>
                  <KickImage src={Continue} alt="..." />
                </div>
              </div>
            </div>
          }
        </div>

        <HowDoesOfferWorks isOpen={openOfferInfo} onToggle={() => setOpenOfferInfo(!openOfferInfo)} />
        <ModalAlert
          isOpen={modalAlertOpen}
          contentText={"Sorry, this features is not available yet on your country."}
          showButton={false}
          onToggle={() => setModalAlertOpen(!modalAlertOpen)}
        />
      </>
    );
  }

  if (state.currentPage === "2") {
    const isWomen = () => {
      return (display_name.includes("(W)") || display_name.includes("[W]")) || false
    }

    const __isHotProduct = () => {
      //_product?.editors_choice <- hot product
      if (sizeCollapse !== "USED" && !isVintage && sizeCollapse !== "PO" && isShowHotProductInfo) {
        return true
      }
      return false
    }

    return (
      <div className="left-content-2">
        <div className="category-button-wrapper">
          <div className="back-btn" onClick={() => handleCurrentPage("1")}>
            <KickImage src={BackButton} alt="..." />
          </div>
          {_renderModalSizeChart()}
        </div>
        <div className="category-btn-container">
          {
            !isVintage ?
              <>
                {preOrderSizes.length > 0 && <Button
                  style={{ order: 3 }}
                  className="category-btn"
                  outline
                  active={sizeCollapse === "PO" ? true : false}
                  onClick={() => {
                    onSizeCollapseChanged("PO")
                    setIsShowPreferiviedInfo(false)
                  }}
                  disabled={preOrderSizes.length === 0}
                >
                  Pre-Order
                </Button>}
                {usedSizes.length > 0 && <Button
                  style={{ order: 2 }}
                  className="category-btn"
                  outline
                  active={sizeCollapse === "USED" ? true : false}
                  onClick={() => {
                    onSizeCollapseChanged("USED")
                    setIsShowPreferiviedInfo(false)
                  }}
                  disabled={usedSizes.length === 0}
                >
                  Used
                </Button>}
                {availableSizes.length > 0 && <Button
                  style={{ order: 1 }}
                  className="category-btn"
                  outline
                  active={
                    sizeCollapse === "NEW" && availableSizes.length > 0
                      ? true
                      : false
                  }
                  onClick={() => {
                    onSizeCollapseChanged("NEW")
                    setIsShowPreferiviedInfo(false)
                  }}
                  disabled={availableSizes.length === 0}
                >
                  Brand New
                </Button>}
              </>
              :
              <Button
                style={{ order: 1 }}
                className="category-btn"
                outline
                active={
                  vintageList.length > 0
                    ? true
                    : false
                }
                // onClick={() => onSizeCollapseChanged("NEW")}
                disabled={vintageList.length === 0}
              >
                VINTAGE
              </Button>
          }
        </div>
        <div className={`size-list-table ${biddable ? "" : "hide-make-offer"}`}>
          <div className="scroll-container">
            <Sizes
              installments={installments}
              variant={variant}
              onSizeChanged={onSizeChanged}
              onToggle={onSizeCollapseChanged}
              selected={selectedSize}
              availableSizes={availableSizes}
              usedSizes={usedSizes}
              preOrderSizes={preOrderSizes}
              vintageList={vintageList}
              isVintage={isVintage}
              collapse={sizeCollapse}
              onBuy={onBuy}
              onOfferClick={onOfferClick}
              isVilla={_isVilla()}
              buttonBuyOffer={renderButtonBuyOffer()}
              handbagCondition={handbagCondition}
              handleCurrentPage={goToAddToBagSection}
              isWomen={isWomen()}
              biddable={biddable}
              showPreverifiedInfoHandler={showPreverifiedInfoHandler}
              showHotProductInfoHandler={showHotProductInfoHandler}
            />
          </div>
        </div>
        <div className="info-promo-container">
          <div className={`info-promo-btn ${(!__isHotProduct() && !isShowPreferiviedInfo && sizeCollapse !== "PO") ? "hide" : ""} ${isVintage ? "vintage" : ""}`}>
            {
              __isHotProduct() ? (
                <RenderCategoryInformation
                  imgUlr={HotProductIcon}
                  text={"Special discount applies"}
                  classnames={"hot-product"}
                />
              ) : null
            }
            {
              sizeCollapse === "PO" ?
                <RenderCategoryInformation
                  imgUlr={null}
                  text={`Pre-orders can take ${etaTextObject?.eta_preorder} ${etaTextObject?.eta_preorder == "1" ? "week" : "weeks"} to complete, depending on sellers location.`}
                  classnames={"pre-orders"}
                />
                :
                isShowPreferiviedInfo ? <RenderCategoryInformation
                  imgUlr={isKickFairActive ? KaFair : PreVerifiedIcon}
                  text={isKickFairActive ? `${etaTextObject?.eta_preverified_event ?? ""}` : `${etaTextObject?.eta_preverified ?? ""}`}
                  classnames={`pre-verified ${__isHotProduct() ? 'with-hot-product' : ''}`}
                /> : null
            }
          </div>
        </div>
      </div>
    );
  }

  function renderSizeChart() {
    if (category !== "lifestyle" && category !== "lifestyles" && category !== "toys" && category !== "electronics-collectibles" && category !== "handbags" && category !== "luxury") {
      return <SizeChart flaggingIsOpenSizeChart={setOpenSizeChart} category={category} />
    }
  }

  return (
    <div className="left-content-1">
      <div className={`content-1-per-row ${_product?.editors_choice ? "" : "no-option"}`}>
        <div className="category-info-container">
          {_product?.editors_choice && <div className="hot-product">
            <KickImage src={HotProductIconWhite} />
            <p>Hot Product</p>
          </div>}
          {false && <div className="most-popular">
            <p>Most Popular</p>
          </div>}
          {false && <div className="best-selling">
            <p>Best Selling</p>
          </div>}
        </div>
        <div className="sell-wishlist-btn">
          {renderSellButton()}
          {/* <div className="whishlist-btn">
            <p>Wishlist</p>
          </div> */}
        </div>
      </div>
      <div className="content-1-per-row">
        <h1>{display_name}</h1>
      </div>
      <div className="content-1-per-row">
        <div className="start-name">
          {start_from_price && <p>start from</p>}
          <div className={`price-wrapper ${start_from_price ? "" : "out-of-stock"}`}>
            <p>
              {start_from_price ? `${formatCurrency(+start_from_price, userCurrency.ratio, userCurrency.currency)}` : "Out of Stock"}
            </p>
            {renderSizeChart()}
          </div>
        </div>
      </div>
      <div className="content-1-per-row">
        {/* RENDER BUTTON CONDITION */}
        {(window.innerWidth <= 769 ? !openModalSizeChart ? true : false : true) ? <div className={`product-condition-btn ${isVintage ? "vintage" : ""}`}>
          {
            !isVintage ?
              <>
                <div
                  className={`btn ${is.disableBrandNew ? "disabled" : ""} `}
                  onClick={() => !is.disableBrandNew && handleCurrentPage("2", "NEW")}
                >
                  <p>Brand New</p>
                </div>
                <div
                  className={`btn ${is.disablePreOwned ? "disabled" : ""} `}
                  onClick={() =>
                    !is.disablePreOwned && handleCurrentPage("2", "USED")
                  }
                >
                  <p>Used</p>
                </div>
                <div
                  className={`btn ${is.disablePreOrder ? "disabled" : ""} `}
                  onClick={() => !is.disablePreOrder && handleCurrentPage("2", "PO")}
                >
                  <p>Pre-Order</p>
                </div>
              </>
              :
              <>
                <div
                  className={`btn ${is.disableVintage ? "disabled" : ""} `}
                  onClick={() => !is.disableVintage && handleCurrentPage("2", "VINTAGE")}
                >
                  <p>Vintage</p>
                </div>
              </>
          }
        </div>
          : null}
      </div>
      <div className="content-1-per-row">
        <div className="line-section">
          <div className="note-title-wrapper"
            onClick={() => {
              setIsOpenTopNote(!isOpenTopNote);
              setIsOpenBottomNote(false);
            }}
          >
            <p>Please Make Sure The Size Fits You.</p>
            <KickImage
              src={isOpenTopNote ? MinusIcon : PlusIcon}
              alt="..."
            />
          </div>
          <Collapse isOpen={isOpenTopNote}>
            <span>
              If you unsure regarding your size, please click the size chart
              button and browse through the chart to find yout correct
              measurements. For more details, kindly add our Customer Service to
              consult further.
            </span>
          </Collapse>
        </div>
        <div className="line-section">
          <div
            className="note-title-wrapper"
            onClick={() => {
              setIsOpenTopNote(false);
              setIsOpenBottomNote(!isOpenBottomNote);
            }}
          >
            <p>Authentic. Guaranteed.</p>
            <KickImage
              src={isOpenBottomNote ? MinusIcon : PlusIcon}
              alt="..."
            />
          </div>
          <Collapse isOpen={isOpenBottomNote}>
            <span>
              We thoroughly check every purchase you make and applies our company's guarantee to the product's legitimacy. The guarantee is valid for 2 days after receiving the product from the delivery service. Should you have any concern about the product you purchase, kindly reach out to our Customer Service and Specialist on Monday - Saturday 10.00 - 21.00 (GMT+7 / WIB).
            </span>
          </Collapse>
        </div>
      </div>
      <div className="content-1-per-row">
        <p>Share this product to your friends!</p>
        <div className="medsos-icon">
          <div className="icon-wrapper"
            onClick={() => window.open("https://www.instagram.com/kick.avenue/", '_blank')}
          >
            <KickImage src={InstagramIcon} alt="..." />
          </div>
          <FacebookShareButton url={shareUrl} className="icon-wrapper">
            <KickImage src={FacebookIcon} alt="..." />
          </FacebookShareButton>
          <WhatsappShareButton url={shareUrl} className="icon-wrapper">
            <KickImage src={WhatsappIcon} alt="..." />
          </WhatsappShareButton>
          <TwitterShareButton
            url={shareUrl}
            className="icon-wrapper"
          >
            <KickImage src={TwitterIcon} alt="..." />
          </TwitterShareButton>
          <div className="icon-wrapper"
            onClick={() => window.open("mailto:info@kickavenue.com", '_blank')}
          >
            <KickImage src={EmailIcon} alt="..." />
          </div>
          <div className="icon-wrapper"
            onClick={() => { navigator.clipboard.writeText(shareUrl) }}
          >
            <KickImage src={CopyIcon} alt="..." />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isKickFairActive: state.dataKaFair.isKickFairActive,
  globalValue: state.globalValue,
  dataValidations: { bid: state.dataOffer.bidValidation },
  dataValidateOffer: state.dataOffer.validateOffer,
  offerPending: state.dataOffer.offerPending,
  dataAuth: state.dataAuth,
});

const mapDispatchToProps = (dispatch) => ({
  postShoppingCartProduct: (payload) =>
    dispatch(postShoppingCartProduct(payload)),
  doPostUserOffer: payload => dispatch(doPostUserOffer(payload)),
  doBidValidation: (payload) => dispatch(doBidValidation(payload)),
  doFetchOfferPending: (payload) => dispatch(doFetchOfferPending(payload)),
  getTicketListSetting: () => dispatch(getTicketListSetting())
});

export default connect(mapStateToProps, mapDispatchToProps)(LeftContent);
